import { render, staticRenderFns } from "./TableStaffSearchBarComponent.vue?vue&type=template&id=1f707d22"
import script from "./TableStaffSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./TableStaffSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./TableStaffSearchBarComponent.vue?vue&type=style&index=0&id=1f707d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports